import styled from 'styled-components';

export const WrapperPopover = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: fit-content;
  height: fit-content;
`;
